import '.bk{flex-shrink:0;}.ssr-plugin'
import '.bm{padding:1rem;}.ssr-plugin'
import '.a0{width:100%;}.ssr-plugin'
import '.bl{height:100%;}.ssr-plugin'
import '.bb{border:none;}.ssr-plugin'
import '.bc{background-color:transparent;}.ssr-plugin'
import '.fg{border-radius:0px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.m{flex-direction:column;}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.d1{position:sticky;}.ssr-plugin'
import '.fh{top:4rem;}.ssr-plugin'
import '.fi{z-index:7;}.ssr-plugin'
import '.ae{background-color:var(--shades-white);}.ssr-plugin'
import '.fj{padding-bottom:1rem;}.ssr-plugin'
import '.u{margin-bottom:1rem;}.ssr-plugin'
import '.fk{border-bottom:var(--blue-border);}.ssr-plugin'
import '.a5{position:fixed;}.ssr-plugin'
import '.ck{top:0;}.ssr-plugin'
import '.bp{left:0px;}.ssr-plugin'
import '.bq{right:0px;}.ssr-plugin'
import '.fl{bottom:0px;}.ssr-plugin'
import '.e8{z-index:9999;}.ssr-plugin'
import '.fm{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.cz{justify-content:flex-end;}.ssr-plugin'
import '.bn{flex:1;}.ssr-plugin'
import '.ar{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { Button } from '@app/components/core/button/Button'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="bk bm a0 bl bb bc fg"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="a m ab"
    >
      <div className="d1 fh fi ae fj u fk a"
      >
        <Button
          variant="link"
          label={collapsedButtonLabel}
          onClick={() => setIsOpen(true)}
        />
      </div>

      <div className="a5 ck bp bq fl e8 ae fm a m"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="bm a cz fk"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="bn ar">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
